import * as React from "react";
import {
  IPeerGroupTabsProps,
  IVisualizationState,
  IFilter,
  getPerformanceTrendData,
} from "../../lib/http";
import * as ReactHighcharts from "react-highcharts";
import PanelGraph from "app/components/tabs/PanelGraph";
const HighchartsMore = require("highcharts/highcharts-more");
HighchartsMore(ReactHighcharts.Highcharts);

export class PeerGroupTrend extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
  > {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  mapFilterIdToColumn(filterId) {
    if (filterId === 0) return '';
    if (filterId === 2) return 'fiveHundredMillionIndex';
    if (filterId === 3) return 'fiftyMillionIndex';
    if (filterId === 4) return 'fiveMillionIndex';
    if (filterId === 5) return 'twentyFiveMillionIndex';
    if (filterId === 6) return 'twoMillionIndex';
    if (filterId === 7) return 'oneHundredMillionIndex';
    if (filterId === 8) return 'tenMillionIndex';
    if (filterId === 9) return 'oneMillionIndex';
  }

  loadSeries(filters: IFilter) {
    const performanceBody = {
      action: "getPerformanceTab",
      request: { assetLevel: this.props.filters.assetLevel },
    }
    const column = this.mapFilterIdToColumn(filters.assetLevel)
    getPerformanceTrendData(performanceBody).then((response) => {

      const peerGroupData = response.map((dataPoint) => {
        return { x: dataPoint['date'], y: dataPoint[column] }
      })

      const givData = response.map((dataPoint) => {
        return { x: dataPoint['date'], y: dataPoint['giv'] }
      })

      //TODO: Hide peerGroup data if the fitlers.assetLevel = 0
      const categories = response.map(dataPoint => dataPoint['date'])
      const series = [{
        color: '',
        name: 'GIV Index',
        data: givData
      }]

      if (column !== '') {
        series.push({
          color: '#B4C6E7',
          name: filters.assetName + ' Index',
          data: peerGroupData
        })
      }

      this.setState({ categories, series })
    })
  }

  static getChartConfig(series, categories, title) {
    return {
      chart: { type: "line", height: 525 },
      title: {
        text: title,
        style: {
          fontSize: "1.6rem",
          color: "#00B050",
        },
        floating: true,
        x: 75,
        y: 150,
        align: "left",
        useHTML: true,
      },
      yAxis: {
        title: { text: "Index", style: { fontWeight: "bold" } },
        min: 50,
      },
      xAxis: { type: "datetime", max: Date.now() },
      legend: {
        enabled: true,
        padding: 12,
        align: "left",
        verticalAlign: "top",
        layout: "proximate",
        x: 75,
        y: 25,
      },
      plotOptions: {
        area: {
          marker: {
            enabled: false,
          },
          label: {
            enabled: true,
          },
        },
        series: {
          events: {
            legendItemClick: function () {
              return false;
            },
          },
        },
      },
      tooltip: {
        headerFormat: "<b>{series.name}</b><br>",
        pointFormat: "",
      },
      credits: {
        enabled: false,
      },
      series,
    }
  }

  render() {
    const { title, loading, series, categories } = this.state
    return <PanelGraph title="" loading={loading} chartConfig={PeerGroupTrend.getChartConfig(series, categories, title)} />;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Performance/PeerGroupTrend/index.tsx